import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const cities = async (data: LocationReqT) => {
  const { id, name, pageParam } = data;

  const qs = `${id ? "/" + id : ""}?page=${pageParam ?? 1}&q=${name ?? ""}`;
  return axios.get(Routes.CITIES + qs);
};

export const useCities = (params: LocationReqT) => {
  const { id, name } = params;
  return useInfiniteQuery({
    queryKey: [Keys.CITIES_QRY, id, name],
    queryFn: ({ pageParam = 1 }) => cities({ pageParam, id, name }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    cacheTime: 0,
  });
};
